import React from 'react';
import { Form, Card } from 'react-bootstrap';
import ModeComponent from '../../ModeComponent';

export default class EarlyTime extends ModeComponent {
  // properties set on each mount
  clockType = 'mechanics';
  defaultFocus = 'earlyTimeInput';
  mode = 'ET';

  schema = {
    earlyTimeInput: {
      errorText: 'Required field',
      label: 'Early Time',
      required: true,
    },
  };

  state = {
    earlyTimeInput: {
      value: '',
      validationState: null,
    },
  };
  // end properties reset on each mount

  render() {
    return (
      <Card className="success">
        <Card.Header>
          <Card.Title>Action Details</Card.Title>
        </Card.Header>
        <Card.Body>
          <Form
            onSubmit={e => {
              e.preventDefault();
            }}
          >
            {this.validatedTextInput('earlyTimeInput')}
          </Form>
        </Card.Body>
      </Card>
    );
  }
}
